import React from 'react'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'
import styled from 'styled-components'
import messages from '@App/session/messages'
import { ButtonLink } from '@Components/Button'
import { presenterHub } from '@RestApi/types'
import Spinner from '@Components/Spinner'
import RequestEmail from './RequestEmail'
import RequestPassword from './RequestPassword'

type props = {
  hub: presenterHub
  showResetPassword: () => void
  action: string
  loading: boolean
  isAuthorized: boolean
  badEmailError: boolean
  emptyEmailError: boolean
  emailAddress: string
  password: string
  handleSetEmailAddress: (e: React.ChangeEvent<HTMLInputElement>) => void
  resetAction: () => void
  handleEmailSubmit: () => void
  handlePasswordSubmit: (password: string) => void
  handleSignIn: () => Promise<void>
}

const EmailSignInForm: React.FC<props> = (props: props) => {
  const {
    hub,
    showResetPassword,
    loading,
    action,
    isAuthorized,
    emailAddress,
    password,
    badEmailError,
    emptyEmailError,
    handleSetEmailAddress,
    resetAction,
    handleEmailSubmit,
    handlePasswordSubmit,
    handleSignIn,
  } = props

  const isJoinEnabled = hub.settings.enable_join_now
  const joinNowUrl = hub.settings.join_now_url
  const hubName = hub.name

  const renderForgotPassword = () => {
    return (
      <ResetPassword>
        <StyledButtonLink onClick={onForgotPasswordClick}>
          <HubFormattedMessage {...messages.havingTroubleSigningIn} />
        </StyledButtonLink>
      </ResetPassword>
    )
  }

  const onForgotPasswordClick = () => {
    showResetPassword()
  }

  const renderJoinCommunityString = () => {
    if (!(isJoinEnabled && joinNowUrl)) return null
    return (
      <div style={{ fontSize: '12px' }}>
        <HubFormattedMessage {...messages.notMember} />
        <StyledButtonLink onClick={() => window && (window.location.href = joinNowUrl)}>
          <HubFormattedMessage {...messages.joinOurCommunity} />
        </StyledButtonLink>
      </div>
    )
  }

  const renderInput = () => {
    if (loading || action === 'auth-success') {
      return <Spinner />
    }
    if (action === 'ask-email') {
      return (
        <RequestEmail
          emailAddress={emailAddress}
          badEmailError={badEmailError}
          emptyEmailError={emptyEmailError}
          handleEmailSubmit={handleEmailSubmit}
          handleSetEmailAddress={handleSetEmailAddress}
        />
      )
    } else if (action === 'ask-password') {
      return (
        <RequestPassword
          emailAddress={emailAddress}
          hubName={hubName}
          resetAction={resetAction}
          handlePasswordSubmit={handlePasswordSubmit}
          password={password}
          isAuthorized={isAuthorized}
          handleSignIn={handleSignIn}
        />
      )
    }
  }

  return (
    <EmailSignInFormWrapper>
      {renderInput()}
      {action === 'auth-success' ? window.location.reload() : renderForgotPassword()}
      {renderJoinCommunityString()}
    </EmailSignInFormWrapper>
  )
}

export default EmailSignInForm

const EmailSignInFormWrapper = styled.div`
  display: block;
  width: 300px;
  font-family: 'Droid Sans'; //replace with a font from backend
`

const ResetPassword = styled.div`
  text-align: center;
  margin-bottom: 4px;
  display: inline-block;
  font-size: 12px;
`

const StyledButtonLink = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.linkedin};
  margin-left: 10px;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`
